import React from 'react';
import { kebabCase } from 'lodash';
import { ThemeConsumer } from 'styled-components';
import { Text } from '@comicrelief/component-library';
import { changeTextColor } from './utils';

const heading = (node, children, options, headingTag) => {
  if (children[0] !== '') {
    const thisTextColour = changeTextColor(options.background);
    const thisMobileTextColour = options.mobileTextColour;

    return (
      <ThemeConsumer>
        {() => (
          <Text
            tag={headingTag}
            id={`${kebabCase(node.content[0].value)}-anchor`}
            color={thisTextColour}
            mobileColor={thisMobileTextColour}
          >
            {children}
          </Text>
        )}
      </ThemeConsumer>
    );
  }
  return null;
};

export default heading;
